export default {"src":"/_next/static/media/opnai-icon.390aa960.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};